export class CostEstimationType {
  static Standard = 1;
  static Additional = 3;
}
